import { Error } from './error';

export const ChallengeFailedErrorCode = 'be.api.challenge.failed';


export interface ChallengeFailure {
	errors: Error[];
}

export function isChallengeFailure<T>(result: T | ChallengeFailure): result is ChallengeFailure {
	return Array.isArray((result as ChallengeFailure | null | undefined)?.errors);
}

export async function parseChallengeFailure(response: { json: () => Promise<ChallengeFailure> }, fallbackMessage: string): Promise<ChallengeFailure> {
	try {
		const body = await response.json();
		if (body?.errors?.length) {
			return { errors: body.errors };
		}
	} catch (e) {
		// If the decoding fails just fall through
	}
	return { errors: [{ code: ChallengeFailedErrorCode, message: fallbackMessage }] };
}
